module.exports = __webpack_public_path__ + "static/media/synctrackblog.d0ef51f8.png";